import React, { useEffect, useState } from "react";
import logo1 from "../../assets/images/logo/logo1.svg";
import logo2 from "../../assets/images/logo/logo2.svg";
import lightMode from "../../assets/images/light-mode.svg";
import "./NavBar.css";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toggle, show, hide } from "../../redux/slice/navactive";
import { active } from "../../redux/slice/activelink";
import { dptoggle, dpshow } from "../../redux/slice/dropdown";
import { Tooltip } from "react-tooltip";
import { setUserDetails } from "../../redux/slice/user";
import { activeTheme } from "../../redux/slice/theme";
import { getAddons } from "../../services/api/api";

const NavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const lastSegment =
    location.pathname.split("/").filter(Boolean).pop() || "dashboard";
  const navActive = useSelector((state) => state.navActive.value);
  const activeLink = useSelector((state) => state.activeLink.value);
  const dropdown = useSelector((state) => state.dropdown.value);
  const user = useSelector((state) => state.user);
  const userRole = user?.userDetails?.UserRole;
  const section1 = [
    "priority",
    "lead-source",
    "lead-status",
    "photoshoot-type",
    "photographer",
    "telecaller",
  ];
  const [section2, setSection2] = useState(() => {
    const saved = localStorage.getItem("section2");
    return saved ? JSON.parse(saved) : [];
  });
  const section3 = ["teamleads", "users"];
  const theme = useSelector((state) => state.theme.value);
  const [products, setProducts] = useState([]);

  // theme toggle
  const toggleTheme = () => {
    if (theme === "light") {
      document.body.setAttribute("data-theme", "dark");
      localStorage.setItem("theme", "dark");
      dispatch(activeTheme("dark"));
    } else {
      document.body.setAttribute("data-theme", "light");
      localStorage.setItem("theme", "light");
      dispatch(activeTheme("light"));
    }
  };

  // display navbar in responsive
  useEffect(() => {    
    getAddons({superadmin_id : user?.userDetails?.ID, source: "lead-status"})
      .then((response) => {
        if (response.status) {
          let data = response.data.map((item) => item.source_url);          
          setSection2(data);
          localStorage.setItem("section2", JSON.stringify(data));
          setProducts(response.data);
        } else {
          setProducts([]);
        }
      })
      .catch((error) => {
        setProducts([]);
        console.log(error);
      });

    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      document.body.setAttribute("data-theme", savedTheme);
      dispatch(activeTheme(savedTheme));
    } else {
      document.body.setAttribute("data-theme", "light");
      dispatch(activeTheme("light"));
    }

    window.innerWidth < 768 ? dispatch(hide()) : dispatch(show());

    const handleResize = () =>
      window.innerWidth < 768 ? dispatch(hide()) : dispatch(show());

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [user]);

  // display navbar toggle
  useEffect(() => {
    const headerpd = document.getElementById("header");
    if (navActive) {
      headerpd.classList.add("header-pd");
      dispatch(
        dpshow(
          section1.includes(activeLink)
            ? "section1"
            : section2.includes(activeLink)
            ? "section2"
            : section3.includes(activeLink)
            ? "section3"
            : null
        )
      );
    } else {
      headerpd.classList.remove("header-pd");
      dispatch(dpshow(null));
    }
  }, [navActive]);

  // url active tab
  useEffect(() => {
    dispatch(active(lastSegment));
  }, [lastSegment]);

  // logout function
  const logoutMethod = () => {
    Swal.fire({
      title: "Are you sure you want to logout?",
      text: "You will need to log in again to access your account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#28a745",
      confirmButtonText: "Yes, log me out!",
      cancelButtonText: "Cancel",
      customClass: {
        title: "swal2-title-custom",
        htmlContainer: "swal2-text-custom",
        confirmButton: "swal2-confirm-button-custom",
        cancelButton: "swal2-cancel-button-custom",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(setUserDetails({ loggedin: "no", userDetails: {} }));
        dispatch(activeTheme("light"));
        localStorage.clear();
        localStorage.setItem("logoutSuccess", "Logout Successful!");
        navigate("/login");
      }
    });
  };

  return (
    <div>
      <header className={`header ${navActive ? "header-pd" : ""}`} id="header">
        <div className="header-toggle" onClick={() => dispatch(toggle())}>
          {navActive ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              className="svg-toggle"
            >
              <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              className="svg-toggle"
            >
              <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" />
            </svg>
          )}
        </div>
        <div className="flex">
          {theme === "light" ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
              className="svg-theme"
              data-tooltip-id="darkTooltip"
              data-tooltip-content="Dark Mode"
              data-tooltip-offset={15}
              onClick={toggleTheme}
            >
              <path d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z" />
            </svg>
          ) : (
            <img
              className="svg-theme"
              src={lightMode}
              alt="lightMode"
              data-tooltip-id="lightTooltip"
              data-tooltip-content="Light Mode"
              data-tooltip-offset={15}
              onClick={toggleTheme}
            />
          )}
          <Tooltip id="darkTooltip" className="tooltip" />
          <Tooltip id="lightTooltip" className="tooltip" />
          <div className="header-user">
            <div className="user-info text-end">
              <h6 className="m-0">{user?.userDetails?.UserName}</h6>
              <p className="m-0">{(user.userDetails.UserID) ? "User" : (user.userDetails.TeamLeadID) ? "Team Lead" : "Super Admin"}</p>
            </div>
            <div
              className="user-icon"
              data-tooltip-id="headerTooltip"
              data-tooltip-html={`
                                <h6 class='m-0'><b>${
                                  user?.userDetails?.UserName
                                }</b></h6>
                                <p class='m-0'>${
                                  (user.userDetails.UserID) ? "User" : (user.userDetails.TeamLeadID) ? "Team Lead" : "Super Admin"
                                }</p>
                              `}
              data-tooltip-place="bottom"
              data-tooltip-offset={15}
            >
              <h2>
                <b>{user?.userDetails?.UserName[0]}</b>
              </h2>
            </div>
            <Tooltip
              id="headerTooltip"
              place="bottom"
              className="tooltip d-sm-none"
            />
          </div>
        </div>
      </header>

      <div className={`side-navbar ${navActive ? "shownav" : ""}`}>
        <nav className="nav">
          <div className="w-100">
            <div className="logo-div">
              {theme === "dark" ? (
                <img className="logo-img" src={logo1} alt="logo" />
              ) : (
                <img className="logo-img" src={logo2} alt="logo" />
              )}
              {navActive && (
                <div>
                  <p className="logo-name m-0">Leadsplugin</p>
                  <p className="logo-sub-name m-0">by kisslead</p>
                </div>
              )}
            </div>

            <div className="menu-list">
              <Link
                className={`nav-link ${
                  activeLink === "dashboard" ? "active" : ""
                }`}
                onClick={() => {
                  dispatch(active("dashboard"));
                  dispatch(dpshow(null));
                }}
                to="/"
                data-tooltip-id="dashboardTooltip"
                data-tooltip-content="Dashboard"
                data-tooltip-offset={15}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                  className="nav-svg"
                >
                  <path d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
                </svg>
                {navActive && <span className="nav-name">Dashboard</span>}
              </Link>
              {!navActive && (
                <Tooltip id="dashboardTooltip" className="tooltip" />
              )}

              {((userRole === "Super Admin") || (userRole === "Admin")) && (
                <li>
                  <a
                    className={`nav-link mb-2 ${
                      section3.includes(activeLink) ? "ddactive" : ""
                    }`}
                    role="button"
                    onClick={() => {
                      dispatch(show());
                      dispatch(dptoggle("section3"));
                    }}
                    data-tooltip-id="teamsTooltip"
                    data-tooltip-content="Teams"
                    data-tooltip-offset={15}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                      className="nav-svg"
                    >
                      <path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z" />
                    </svg>

                   
                    {navActive && (
                      <span className="nav-name">
                        Teams
                        {dropdown === "section3" ? (
                          <span className="arrow">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 320 512"
                              className="nav-svg"
                            >
                              <path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
                            </svg>
                          </span>
                        ) : (
                          <span className="arrow">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 320 512"
                              className="nav-svg"
                            >
                              <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
                            </svg>
                          </span>
                        )}
                      </span>
                    )}
                  </a>
                  {!navActive && (
                    <Tooltip id="teamsTooltip" className="tooltip" />
                  )}
                  <div
                    className={`collapse ${
                      dropdown === "section3" ? "shownav" : ""
                    }`}
                  >
                    <ul className="list-unstyled">

                      { (userRole === "Super Admin") && 
                        <li>
                        <Link
                          className={`nav-link ${
                            activeLink === "teamleads" ? "active" : ""
                          }`}
                          onClick={() => {
                            dispatch(active("teamleads"));
                            dispatch(dpshow("section3"));
                          }}
                          to="/teamleads"
                        >
                          <span className="nav-name ps-3">Team Leads</span>
                        </Link>
                      </li>
                      }
                    
                      <li>
                        <Link
                          className={`nav-link ${
                            activeLink === "users" ? "active" : ""
                          }`}
                          onClick={() => {
                            dispatch(active("users"));
                            dispatch(dpshow("section3"));
                          }}
                          to="/users"
                        >
                          <span className="nav-name ps-3">Users</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              )}

              {((userRole === "Super Admin") || (userRole === "Admin")) && (
                <Link
                  className={`nav-link ${
                    activeLink === "studios" ? "active" : ""
                  }`}
                  onClick={() => {
                    dispatch(active("studios"));
                    dispatch(dpshow(null));
                  }}
                  to="/studios"
                  data-tooltip-id="studioTooltip"
                  data-tooltip-content="Studios"
                  data-tooltip-offset={15}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className="nav-svg"
                  >
                    <path d="M220.6 121.2L271.1 96 448 96l0 96-114.8 0c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24L64 192l0-64 128 0c9.9 0 19.7-2.3 28.6-6.8zM0 128L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L271.1 32c-9.9 0-19.7 2.3-28.6 6.8L192 64l-32 0 0-16c0-8.8-7.2-16-16-16L80 32c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z" />
                  </svg>
                  {navActive && <span className="nav-name">Studios</span>}
                </Link>
              )}
              {!navActive && <Tooltip id="studioTooltip" className="tooltip" />}

              <li>
                <a
                  className={`nav-link mb-2 ${
                    section2.includes(activeLink) ? "ddactive" : ""
                  }`}
                  role="button"
                  onClick={() => {
                    dispatch(show());
                    dispatch(dptoggle("section2"));
                  }}
                  data-tooltip-id="leadtooltip"
                  data-tooltip-content="Leads"
                  data-tooltip-offset={15}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className="nav-svg"
                  >
                    <path d="M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM208 288l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z" />
                  </svg>
                  {navActive && (
                    <span className="nav-name">
                      Leads
                      {dropdown === "section2" ? (
                        <span className="arrow">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                            className="nav-svg"
                          >
                            <path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
                          </svg>
                        </span>
                      ) : (
                        <span className="arrow">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                            className="nav-svg"
                          >
                            <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
                          </svg>
                        </span>
                      )}
                    </span>
                  )}
                </a>
                {!navActive && <Tooltip id="leadtooltip" className="tooltip" />}
                <div
                  className={`collapse ${
                    dropdown === "section2" ? "shownav" : ""
                  }`}
                >
                  <ul className="list-unstyled">
                    {section2.length > 0 &&
                      products.length > 0 &&
                      products.map((item, index) => (
                        <li key={index}>
                          <Link
                            className={`nav-link ${
                              activeLink === `${item.source_url}`
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              dispatch(active(`${item.source_url}`));
                              dispatch(dpshow("section2"));
                            }}
                            to={`/leads/${item.source_url}`}
                          >
                            <span className="nav-name ps-3">
                              {item.source_value}
                            </span>
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              </li>

              {userRole === "Super Admin" && (
                <li>
                  <a
                    className={`nav-link mb-2 ${
                      section1.includes(activeLink) ? "ddactive" : ""
                    }`}
                    role="button"
                    onClick={() => {
                      dispatch(show());
                      dispatch(dptoggle("section1"));
                    }}
                    data-tooltip-id="addonTooltip"
                    data-tooltip-content="Addons"
                    data-tooltip-offset={15}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                      className="nav-svg"
                    >
                      <path d="M248 0L208 0c-26.5 0-48 21.5-48 48l0 112c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-112c0-26.5-21.5-48-48-48L328 0l0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80zM64 256c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-40 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80-40 0zM352 512l160 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-40 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80-40 0c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2l0 160c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z" />
                    </svg>
                    {navActive && (
                      <span className="nav-name">
                        Addons
                        {dropdown === "section1" ? (
                          <span className="arrow">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 320 512"
                              className="nav-svg"
                            >
                              <path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
                            </svg>
                          </span>
                        ) : (
                          <span className="arrow">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 320 512"
                              className="nav-svg"
                            >
                              <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
                            </svg>
                          </span>
                        )}
                      </span>
                    )}
                  </a>
                  {!navActive && (
                    <Tooltip id="addonTooltip" className="tooltip" />
                  )}
                  <div
                    className={`collapse ${
                      dropdown === "section1" ? "shownav" : ""
                    }`}
                  >
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className={`nav-link ${
                            activeLink === "photoshoot-type" ? "active" : ""
                          }`}
                          onClick={() => {
                            dispatch(active("photoshoot-type"));
                            dispatch(dpshow("section1"));
                          }}
                          to="/addons/photoshoot-type"
                        >
                          <span className="nav-name ps-3">Photoshoot Type</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`nav-link ${
                            activeLink === "lead-source" ? "active" : ""
                          }`}
                          onClick={() => {
                            dispatch(active("lead-source"));
                            dispatch(dpshow("section1"));
                          }}
                          to="/addons/lead-source"
                        >
                          <span className="nav-name ps-3">Lead Source</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`nav-link ${
                            activeLink === "lead-status" ? "active" : ""
                          }`}
                          onClick={() => {
                            dispatch(active("lead-status"));
                            dispatch(dpshow("section1"));
                          }}
                          to="/addons/lead-status"
                        >
                          <span className="nav-name ps-3">Lead Status</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`nav-link ${
                            activeLink === "priority" ? "active" : ""
                          }`}
                          onClick={() => {
                            dispatch(active("priority"));
                            dispatch(dpshow("section1"));
                          }}
                          to="/addons/priority"
                        >
                          <span className="nav-name ps-3">Priority</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`nav-link ${
                            activeLink === "telecaller" ? "active" : ""
                          }`}
                          onClick={() => {
                            dispatch(active("telecaller"));
                            dispatch(dpshow("section1"));
                          }}
                          to="/addons/telecaller"
                        >
                          <span className="nav-name ps-3">Telecaller</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`nav-link ${
                            activeLink === "photographer" ? "active" : ""
                          }`}
                          onClick={() => {
                            dispatch(active("photographer"));
                            dispatch(dpshow("section1"));
                          }}
                          to="/addons/photographer"
                        >
                          <span className="nav-name ps-3">Photographer</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              )}

              <Link
                className={`nav-link ${
                  activeLink === "availability" ? "active" : ""
                }`}
                onClick={() => {
                  dispatch(active("availability"));
                  dispatch(dpshow(null));
                }}
                to="/availability"
                data-tooltip-id="availabilityTooltip"
                data-tooltip-content="Availability"
                data-tooltip-offset={15}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  className="nav-svg"
                >
                  <path d="M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z" />
                </svg>
                {navActive && <span className="nav-name">Availability</span>}
              </Link>
              {!navActive && (
                <Tooltip id="availabilityTooltip" className="tooltip" />
              )}

              <Link
                className="nav-link"
                onClick={() => {
                  logoutMethod();
                }}
                data-tooltip-id="signoutTooltip"
                data-tooltip-content="SignOut"
                data-tooltip-offset={15}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="nav-svg"
                >
                  <g transform="scale(-1, 1) translate(-500, 0)">
                    <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z" />
                  </g>
                </svg>
                {navActive && <span className="nav-name">Sign Out</span>}
              </Link>
              {!navActive && (
                <Tooltip id="signoutTooltip" className="tooltip" />
              )}
            </div>

            <div className="footer-user">
              <div className="user-icon">
                <h2
                  data-tooltip-id="footerTooltip"
                  data-tooltip-content={user?.userDetails?.UserName}
                  data-tooltip-offset={20}
                >
                  <b>{user?.userDetails?.UserName[0]}</b>
                </h2>
              </div>
              {navActive && (
                <div className="user-info text-start ms-3">
                  <h6 className="m-0">{user?.userDetails?.UserName}</h6>
                  <p className="m-0">{(user.userDetails.UserID) ? "User" : (user.userDetails.TeamLeadID) ? "Team Lead" : "Super Admin"}</p>
                </div>
              )}
              {!navActive && <Tooltip id="footerTooltip" className="tooltip" />}
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default NavBar;
